module.exports = "/_next/static/images/czechcrunch-eec491f35344a9d8a8a6ba72c357a40b.png";